export function removeDuplicateIdsinArray(arr) {
  if (!Array.isArray(arr)) {
    return [];
  }
  
  const seen = new Set();
  return arr.filter(item => {
    if (seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
}